import axios from "axios";
import mainHelper from "./MainHelper";
import { clearUserInfo, onLoggedin, updateUserInfo } from "../actions";
import { clearPendingVerification, savePendingVerification, getPendingVerification } from './PendingVerification';
const apiUrl = `${process.env.REACT_APP_API_URL}`;

export const handleLogin = (data) => {
    return async (dispatch) => {

        try {
            const response = await axios.post(apiUrl + 'login', data);
            if (response.data && response.data.user) {
                clearPendingVerification();
                localStorage.setItem('user', JSON.stringify(response.data.user));
                localStorage.setItem('isLoggedIn', 'true')
                localStorage.setItem('token', response.data.token);
                dispatch(updateUserInfo(response.data.user));
                dispatch(onLoggedin(true));
            }
            return response;
        } catch (error) {
            if (error.response) {
                if (error.response.status === 403 && error.response.data?.requires_verification) {
                    const email = error.response.data.email || data.email;
                    if (getPendingVerification()?.email !== email) savePendingVerification(email);
                    throw error;
                }
                if (error.response.status === 422) {
                    mainHelper.handleErrors(error.response.data.errors, error.response.status)
                    throw error;
                }
                else if (error.response.status === 401) {
                    mainHelper.toastMessage('error', 'Kullanıcı Bulunamadı!');
                    throw error;
                } else {
                    mainHelper.toastMessage('error', 'Bilinmeyen Hata!');
                    throw error;
                }
            }
            else if (error.request) {
                mainHelper.toastMessage('error', 'Sunucudan cevap alınamadı!')
                throw error;
            } else {
                mainHelper.toastMessage('error', 'Bilinmeyen Hata!')
                throw error;
            }

        }
    }
}
export const handleLogout = (history) => async (dispatch) => {

    var token = localStorage.getItem('token');

    try {
        const response = await axios.get(apiUrl + 'logout', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (response.status === 200) {
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            localStorage.setItem('isLoggedIn', 'false');
            dispatch(clearUserInfo());
            dispatch(onLoggedin(false));
            history.push('/login')
        }
    } catch (e) {
        dispatch(onLoggedin(false));
        throw e;
    }
}
